import {
  UseSuspenseQueryResult,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { StationLocationDto } from "use-smart-locks-shared";
import { getStationLocations } from "../api/nest-api";

export const useWatchStationLocations =
  (): UseSuspenseQueryResult<StationLocationDto[]> =>
    useSuspenseQuery({
      queryKey: ["station-locations"],
      queryFn: getStationLocations,
      refetchInterval: 60_000,
    });
